import Raven from 'raven-js';
import getLang from 'I18n/utils/getLang';

import {
  LocalisedConnectedStatus,
  StatusTypeCategory,
} from '../../__generated__/chirp/com/hubspot/connected/application/status/rpc/frontend/ConnectedStatusGraphQLService';
import { useFetchAllForUserLazyQuery } from '../../__generated__/chirp/com/hubspot/connected/application/status/rpc/frontend/ConnectedStatusGraphQLService.hooks';

type TUseLazyGetAppStatusesArgs = {
  appId: number;
  includeAllNamespaceStatuses?: boolean;
  categories?: StatusTypeCategory[];
};

export type TUseLazyGetAppStatusesResult = {
  data?: LocalisedConnectedStatus[];
  loading: boolean;
  error?: Error;
  fetchStatuses: () => void;
  startPolling: (pollingInterval: number) => void;
  stopPolling: () => void;
};

export const useLazyGetAppStatuses = ({
  appId,
  categories,
  includeAllNamespaceStatuses = false,
}: TUseLazyGetAppStatusesArgs) => {
  const [fetchStatuses, { data, loading, error, startPolling, stopPolling }] =
    useFetchAllForUserLazyQuery<false>({
      variables: {
        locale: getLang(),
        statusFetchOptions: {
          appIds: [appId],
          categories,
          includeAllNamespaceStatuses,
        },
      },
      onError: (err) => {
        Raven.captureException(err, {
          extra: {
            appId,
          },
        });
      },
    });

  return {
    data: data?.results,
    loading,
    error,
    fetchStatuses,
    startPolling,
    stopPolling,
  } as TUseLazyGetAppStatusesResult;
};
